import { Suspense, useEffect } from "react";
import { displayPopin, preloadPopins, useListenPopins } from "../Hook/popins";

function PopinsHolder() {
  const popins = useListenPopins();
  const Element:any = popins.popins[0];

  useEffect(() => {
    if(document.location.href.includes("nodisclaimer")) localStorage.setItem("disclaimer", "true");
    if(!localStorage.getItem("disclaimer") && !document.location.href.includes("nodisclaimer")) displayPopin()("disclaimer")
  }, [])

  useEffect(() => {
    let idleCallback: number | undefined;
    let timeout: ReturnType<typeof setTimeout> | undefined;

    const preload = () => {
      if ("requestIdleCallback" in window) {
        idleCallback = window.requestIdleCallback(() => {
          void preloadPopins();
        }, { timeout: 2000 });
      } else {
        timeout = setTimeout(() => {
          void preloadPopins();
        }, 0);
      }
    };

    if (document.readyState === "complete") {
      preload();
    } else {
      window.addEventListener("load", preload, { once: true });
    }

    return () => {
      window.removeEventListener("load", preload);
      if (idleCallback !== undefined) window.cancelIdleCallback(idleCallback);
      if (timeout !== undefined) clearTimeout(timeout);
    };
  }, []);

  if(!Element) return null;
  return (
    <Suspense fallback={null}>
      <div data-testid="active-popin">
      <Element {...popins.props[0]} />
      </div>
    </Suspense>
  );
}

export default PopinsHolder;
